



























import {oneTimeInterval} from '@/common/utils/helper';
import {Nullable} from '@/common/utils/types';
// @ts-ignore
import SvgArrow from '@/common/svgs/arrow.svg';
import SvgIcon from '@/configurator/components/utils/SvgIcon.vue';

import Vue, {VueConstructor} from 'vue';

const MIN_ANIMATION_DURATION = 300;
const MAX_ANIMATION_DURATION = 600;
const PIXEL_PER_MIN_DURATION = 300;
export default (Vue as VueConstructor<Vue & {
  $refs: {
    content: HTMLElement,
  },
}>).extend({

  components: {
    SvgIcon,
  },

  props: {
    disabled: Boolean,
    isOpen: Boolean,
  },

  data() {
    return {
      _animationInProgress: false,
      _runningIntervals: [] as number[],
      open: false,
      opened: false,
      isOpening: false,
      maxHeight: null as Nullable<number>,
      animationDuration: 300,
    };
  },

  mounted() {
    this._runningIntervals = [];
    if (this.isOpen) {
      this.opened = true;
    }
    // $nextTick is used so that all child components are rendered
    // and maxHeight can be calculated correctly for more details see:
    // https://vuejs.org/v2/api/#mounted
    this.$nextTick(() => {
      this.maxHeight = this.$refs.content.offsetHeight;
      // Adjust animation duration so that it's not extremly fast
      // on big toggles and not super slow on small toggles
      const neededAnimationDuration = (Math.floor(this.maxHeight / PIXEL_PER_MIN_DURATION) * PIXEL_PER_MIN_DURATION) * MIN_ANIMATION_DURATION;
      const calculatedAnimationDuration = Math.min(neededAnimationDuration, MAX_ANIMATION_DURATION);
      const animationDuration = Math.max(calculatedAnimationDuration, MIN_ANIMATION_DURATION);
      this.animationDuration = animationDuration;
      ((this.$el as HTMLElement).style as any).setProperty('--max-height', this.maxHeight + 'px');
      ((this.$el as HTMLElement).style as any).setProperty('--anim-dur', animationDuration + 'ms');
    });
  },

  beforeDestroy() {
    this._cleanUpIntervals();
  },

  computed: {
    heightCalculated(): boolean {
      return (this.maxHeight === null) ? false : true;
    },
    icons(): object {
      return {
        SvgArrow,
      };
    },
  },

  methods: {
    _cleanUpIntervals() {
      this._runningIntervals.forEach((intervalId) => clearInterval(intervalId));
      this._runningIntervals = [];
    },
    async onToggle() {
      if (this.disabled) {
        return;
      }
      if (this._animationInProgress) {
        return;
      }
      this._cleanUpIntervals();
      this._animationInProgress = true;
      const animationIntervalId = oneTimeInterval(() => this._animationInProgress = false, this.animationDuration);
      this._runningIntervals.push(animationIntervalId);
      this.open = !this.open;
      if (this.open) {
        this.isOpening = true;
        const openIntervalId = oneTimeInterval(() => this.opened = true, this.animationDuration);
        this._runningIntervals.push(openIntervalId);
      } else {
        this.opened = false;
        // do it two frames later, to make it more smooth for the user
        // 32 = (1000ms / 60fps) * 2
        const closeIntervalId = oneTimeInterval(() => this.isOpening = false, 32);
        this._runningIntervals.push(closeIntervalId);
      }
    },
  },
});
